import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
    userInfo: {},
    userGroups: [],
    spaceImages: [],
    userHubInfo: {},
    userGroupSpaces: [],
    spaceUsers: [],
    companyLogo: null,
    profilePicture: null,
    userSpaces: []
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserDetail: (state, action) => {
            state.userInfo = action.payload;
        },
        setUserGroups: (state, action) => {
            state.userGroups = action.payload;
        },
        setSpaceImages: (state, action) => {
            state.spaceImages = action.payload
        },
        setUserHubInfo: (state, action) => {
            state.userHubInfo = action.payload
        },
        setUserGroupSpaces: (state, action) => {
            state.userGroupSpaces = action.payload
        },
        setSpaceUsers: (state, action) => {
            state.spaceUsers = action.payload
        },
        setCompanyLogo: (state, action) => {
            state.companyLogo = action.payload
        },
        setProfilePicture: (state, action) => {
            state.profilePicture = action.payload
        },
        setUserSpaces: (state, action) => {
            state.userSpaces = action.payload
        }

    }
});

export const { setUserDetail, setUserGroups, setSpaceImages, setUserHubInfo, setUserGroupSpaces, setSpaceUsers, setCompanyLogo, setProfilePicture, setUserSpaces } = userSlice.actions;

export default userSlice.reducer;